<template>
  <div class="d-flex justify-space-between mt-4">
    <b-modal v-model="confirmCancel" size="md" hide-header hide-footer centered>
      <div class="d-block text-center py-4">
        Are you sure you want to cancel?
        <br />Changes you’ve made will not be saved.
        <b-row class="mt-5">
          <b-col class="text-center">
            <div class="c-pointer" @click="$router.go()">Yes</div>
          </b-col>
          <b-col class="text-center">
            <div
              class="font-weight-bold c-pointer"
              @click="confirmCancel = false"
            >
              No
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      v-model="showErrorMessage"
      size="md"
      hide-header
      hide-footer
      centered
    >
      <div class="d-block text-center py-4">
        {{ errorMessage }}
        <div
          class="mt-5 font-weight-bold c-pointer text-center"
          @click="showErrorMessage = false"
        >
          Close
        </div>
      </div>
    </b-modal>

    <div :class="isMobile ? '' : 'w-50'">
      <b-table-simple hover bordered class="border-0">
        <b-thead>
          <b-tr>
            <b-th
              class="text-center align-center"
              v-for="(field, i) in fields"
              :key="i"
              :class="field === '' ? 'border-0' : ''"
              >{{ field }}</b-th
            >
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="(row, rIndex) in firstTable"
            :key="rIndex"
            :style="row.checked ? 'background-color: #e7f0fb' : ''"
          >
            <!-- Checkbox -->
            <b-td width="50px" class="border-0 bg-none text-center">
              <b-form-checkbox
                v-model="row.checked"
                @change="onSelectCircuit('left', row.checked, rIndex)"
                v-if="
                  !row.group_id ||
                    rIndex === 0 ||
                    row.group_id !== firstTable[rIndex - 1].group_id
                "
                :disabled="!canUpdate"
              ></b-form-checkbox>
            </b-td>

            <!-- CB. NO. -->
            <b-td
              class="text-center cb-no"
              width="50px"
              :style="`background-color: ${row.cb_no_colour}`"
              @click="onAutoFocus(`left-cb-${rIndex}`)"
            >
              <input
                :ref="`left-cb-${rIndex}`"
                class="w-100 border-0 text-center bg-transparent"
                type="text"
                v-model="row.cb_no"
                @input="
                  row.edited = true
                  editing = true
                "
                :disabled="!isBlank || !canUpdate"
              />
            </b-td>

            <!-- Neutral Number -->
            <b-td
              :rowspan="row.group_id !== null ? row.rowspan : 1"
              class="text-center"
              width="50px"
              v-if="
                board.is_neutral_numbers &&
                  (!row.group_id ||
                    rIndex === 0 ||
                    row.group_id !== firstTable[rIndex - 1].group_id)
              "
              @click="onAutoFocus(`left-neutral-${rIndex}`)"
            >
              <input
                :ref="`left-neutral-${rIndex}`"
                class="w-100 border-0 text-center bg-transparent rcd-protected"
                type="number"
                v-model="row.neutral_number"
                @input="
                  row.edited = true
                  editing = true
                "
                :disabled="!canUpdate"
              />
            </b-td>

            <!-- Circuit Rating -->
            <b-td
              :rowspan="row.group_id !== null ? row.rowspan : 1"
              class="text-center"
              width="50px"
              :class="{ 'rcd-protected': row.rcd_protected }"
              v-if="
                !row.group_id ||
                  rIndex === 0 ||
                  row.group_id !== firstTable[rIndex - 1].group_id
              "
              @click="onAutoFocus(`left-circuit-${rIndex}`)"
            >
              <input
                :ref="`left-circuit-${rIndex}`"
                class="w-100 border-0 text-center bg-transparent"
                type="number"
                v-model="row.circuit_rating"
                @input="
                  row.edited = true
                  editing = true
                "
                :disabled="!canUpdate"
              />
            </b-td>

            <!-- Description -->
            <b-td
              :rowspan="row.group_id !== null ? row.rowspan : 1"
              class="text-left"
              v-if="
                !row.group_id ||
                  rIndex === 0 ||
                  row.group_id !== firstTable[rIndex - 1].group_id
              "
              @click="onAutoFocus(`left-description-${rIndex}`)"
            >
              <textarea
                :ref="`left-description-${rIndex}`"
                :rows="
                  row.description && row.description.length > 38
                    ? row.description.length / 38
                    : 1
                "
                class="w-100 border-0 bg-transparent"
                v-model="row.description"
                @input="onInputCell('left', 'description', rIndex)"
                @focus="textAreaAdjust(`left-description-${rIndex}`)"
                :disabled="!canUpdate"
              />
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <div class="mx-2"></div>

    <div :class="isMobile ? 'pr-4' : 'w-50'">
      <b-table-simple hover bordered class="border-0">
        <b-thead>
          <b-tr>
            <b-th
              class="text-center"
              v-for="(field, i) in fields"
              :key="i"
              :class="field === '' ? 'border-0' : ''"
              >{{ field }}</b-th
            >
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="(row, sIndex) in secondTable"
            :key="sIndex"
            :style="row.checked ? 'background-color: #e7f0fb' : ''"
          >
            <!-- Checkbox -->
            <b-td width="50px" class="border-0 text-center">
              <b-form-checkbox
                v-model="row.checked"
                @change="onSelectCircuit('right', row.checked, sIndex)"
                v-if="
                  !row.group_id ||
                    sIndex === 0 ||
                    row.group_id !== secondTable[sIndex - 1].group_id
                "
                :disabled="!canUpdate"
              ></b-form-checkbox>
            </b-td>

            <!-- CB. NO. -->
            <b-td
              class="text-center cb-no"
              width="50px"
              :style="`background-color: ${row.cb_no_colour}`"
              @click="onAutoFocus(`right-cb-${sIndex}`)"
            >
              <input
                :ref="`right-cb-${sIndex}`"
                class="w-100 border-0 text-center bg-transparent"
                type="text"
                v-model="row.cb_no"
                @input="
                  row.edited = true
                  editing = true
                "
                :disabled="!isBlank || !canUpdate"
              />
            </b-td>

            <!-- Neutral Numbers -->
            <b-td
              :rowspan="row.group_id !== null ? row.rowspan : 1"
              class="text-center"
              width="50px"
              v-if="
                board.is_neutral_numbers &&
                  (!row.group_id ||
                    sIndex === 0 ||
                    row.group_id !== secondTable[sIndex - 1].group_id)
              "
              @click="onAutoFocus(`right-neutral-${sIndex}`)"
            >
              <input
                :ref="`right-neutral-${sIndex}`"
                class="w-100 border-0 text-center bg-transparent"
                type="number"
                v-model="row.neutral_number"
                @input="
                  row.edited = true
                  editing = true
                "
                :disabled="!canUpdate"
              />
            </b-td>

            <!-- Circuit Rating -->
            <b-td
              :rowspan="row.group_id !== null ? row.rowspan : 1"
              class="text-center"
              :class="{ 'rcd-protected': row.rcd_protected }"
              width="50px"
              v-if="
                !row.group_id ||
                  sIndex === 0 ||
                  row.group_id !== secondTable[sIndex - 1].group_id
              "
              @click="onAutoFocus(`right-circuit-${sIndex}`)"
            >
              <input
                :ref="`right-circuit-${sIndex}`"
                class="w-100 border-0 text-center bg-transparent"
                type="number"
                v-model="row.circuit_rating"
                @input="
                  row.edited = true
                  editing = true
                "
                :disabled="!canUpdate"
              />
            </b-td>

            <!-- Description -->
            <b-td
              :rowspan="row.group_id !== null ? row.rowspan : 1"
              class="text-left"
              v-if="
                !row.group_id ||
                  sIndex === 0 ||
                  row.group_id !== secondTable[sIndex - 1].group_id
              "
              @click="onAutoFocus(`right-description-${sIndex}`)"
            >
              <textarea
                :ref="`right-description-${sIndex}`"
                :rows="
                  row.description && row.description.length > 38
                    ? row.description.length / 38
                    : 1
                "
                class="w-100 border-0 bg-transparent"
                v-model="row.description"
                @input="onInputCell('right', 'description', sIndex)"
                @focus="textAreaAdjust(`right-description-${sIndex}`)"
                :disabled="!canUpdate"
              />
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <div
      v-if="showActionButtons && canUpdate"
      class="floating-bar"
      :class="{ isMobile }"
    >
      <b-button
        :style="isMobile ? 'font-size: 12px; width: 150px' : 'background: none'"
        :class="{ isMobile }"
        class="my-3 mx-3 cancel"
        @click="onClickCancel"
        >Cancel</b-button
      >
      <b-button
        :style="isMobile ? 'font-size: 12px' : ''"
        :class="{ isMobile }"
        class="my-3 mr-3 group"
        :disabled="circuits.length <= 1 || loading"
        @click="groupSchedules"
        >Group Circuits</b-button
      >
      <b-button
        :style="isMobile ? 'font-size: 12px' : ''"
        :class="{ isMobile }"
        class="my-3 mr-3 ungroup"
        :disabled="
          !(circuits.length === 1 && circuits[0].group_id !== null) || loading
        "
        @click="ungroupSchedules"
        >Ungroup Circuits</b-button
      >
      <!-- v-model="toggleRCD" -->
      <b-form-checkbox
        v-model="toggleRCD"
        class="rcd-toggle"
        button
        button-variant="primary"
        :class="{ isMobile }"
        @change="handleRCDProtected"
        :disabled="disabledToggleRCD"
      >
        <b-form-checkbox
          v-model="toggleRCD"
          class="rcd-checkbox"
          :disabled="disabledToggleRCD"
        />
        RCD Protected
      </b-form-checkbox>
      <b-button
        :style="isMobile ? 'font-size: 12px' : ''"
        :class="{ isMobile }"
        class="my-3 save"
        @click="submit"
        :disabled="loading"
        >Save Changes</b-button
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    canUpdate: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      leftPoles: [],
      rightPoles: [],
      circuits: [],
      loading: false,
      editing: false,
      showActionButtons: false,
      confirmCancel: false,
      showErrorMessage: false,
      toggleRCD: false,
      errorMessage: ''
    }
  },
  watch: {
    circuits(value) {
      if (value.length) {
        this.showActionButtons = true

        this.toggleRCD = value.some(item => !item.rcd_protected)
      }
    }
  },
  computed: {
    ...mapState({
      board: state => state.board.boardDetails
    }),
    disabledToggleRCD() {
      return (
        (this.circuits.some(item => item.rcd_protected) &&
          this.circuits.some(item => !item.rcd_protected)) ||
        !this.canUpdate ||
        !this.circuits.length ||
        this.loading
      )
    },
    isBlank() {
      return this.board.numbering_format === 'blank'
    },
    fields() {
      return this.board && this.board.is_neutral_numbers
        ? ['', 'CB. NO.', 'NEUTRAL NUMBER', 'CIRCUIT RATING', 'DESCRIPTION']
        : ['', 'CB. NO.', 'CIRCUIT RATING', 'DESCRIPTION']
    },

    halfPoles() {
      return parseInt(this.board.number_of_poles / 2)
    },

    isPoleNumberEven() {
      return this.board.number_of_poles % 2 === 0
    },

    firstTable() {
      return this.leftPoles
    },

    secondTable() {
      return this.rightPoles
    }
  },

  methods: {
    ...mapActions({
      updateSchedule: 'board/updateBoardSchedule',
      groupBoardSchedule: 'board/groupBoardSchedule',
      updateRCDProtected: 'board/updateRCDProtected',
      ungroupBoardSchedule: 'board/ungroupBoardSchedule'
    }),

    async handleRCDProtected() {
      this.toggleRCD = this.circuits.some(item => !item.rcd_protected)

      const form = new FormData()
      this.circuits.forEach(circuit => {
        form.append('schedule_ids[]', circuit.id)
      })
      this.loading = true
      await this.updateRCDProtected(form)
      this.loading = false
      this.reset()
    },

    onInputCell(table, field, index) {
      if (table === 'left') {
        this.leftPoles[index].edited = true
      } else {
        this.rightPoles[index].edited = true
      }
      this.editing = true
      this.textAreaAdjust(`${table}-${field}-${index}`)
    },

    onAutoFocus(refName) {
      this.$nextTick(() => {
        if (this.canUpdate) {
          if (!this.$refs[refName][0].disabled) {
            this.showActionButtons = true
            this.$refs[refName][0].focus()
          }
        }
      })
    },

    onSelectCircuit(table, checked, index) {
      if (table === 'left') {
        if (checked) {
          this.circuits.push(this.leftPoles[index])
        } else {
          this.circuits.splice(this.circuits.indexOf(this.leftPoles[index]), 1)
        }
      } else {
        if (checked) {
          this.circuits.push(this.rightPoles[index])
        } else {
          this.circuits.splice(this.circuits.indexOf(this.rightPoles[index]), 1)
        }
      }
    },
    onClickCancel() {
      if (this.editing) {
        this.confirmCancel = true
      } else {
        this.showActionButtons = false
      }
    },

    getPoles(pos) {
      let poles = []

      // left poles
      let i = 0
      let totalPoles = this.isPoleNumberEven
        ? this.halfPoles
        : this.halfPoles + 1

      // right poles
      if (pos === 'right') {
        i = totalPoles
        totalPoles = this.isPoleNumberEven
          ? this.board.number_of_poles
          : this.board.number_of_poles
      }

      for (i; i < totalPoles; i++) {
        let groupId = this.board.schedules[i].group_id
        let neutralNo = this.board.schedules[i].neutral_number
        let circuitRating = this.board.schedules[i].circuit_rating

        poles.push({
          id: `${this.board.schedules[i].schedule_id}`,
          cb_no: this.board.schedules[i].cb_no,
          rcd_protected: this.board.schedules[i].rcd_protected,
          cb_no_colour: this.board.schedules[i].cb_no_colour,
          neutral_number: neutralNo === 0 ? null : neutralNo,
          circuit_rating: circuitRating === 0 ? null : circuitRating,
          description: this.board.schedules[i].description,
          group_id: groupId,
          checked: false,
          edited: false,
          rowspan: this.board.schedules.filter(
            (v, i, a) => a[i].group_id !== null && a[i].group_id === groupId
          ).length
        })
      }

      return poles
    },

    async groupSchedules() {
      this.loading = true

      // check if selected circuits are consecutive
      const scheduleIds = this.circuits.map(item => item.id)
      const { min, max } = scheduleIds.reduce(
        (prev, curr) => {
          const id = parseInt(curr)
          if (id > prev.max) {
            prev.max = id
            if (prev.min === 0) {
              prev.min = id
            }
          } else if (id < prev.min) {
            prev.min = id
          }

          return prev
        },
        { min: 0, max: 0 }
      )
      const areNotConsecutive = max - min !== this.circuits.length - 1
      const belongsToDifferentSide =
        this.leftPoles.some(item => scheduleIds.includes(item.id)) &&
        this.rightPoles.some(item => scheduleIds.includes(item.id))

      if (areNotConsecutive || belongsToDifferentSide) {
        this.showErrorMessage = true
        this.errorMessage =
          'Unable to group circuits. Make sure the selected circuits are consecutive rows and do not belong to any group yet.'
      } else {
        await this.groupBoardSchedule({
          schedules: this.circuits
        }).catch(err => {
          if (err.response) {
            this.showErrorMessage = true
            this.errorMessage = err.response.data.message
          }
        })
        await this.submit(true)
      }
      !this.editing && this.reset()
    },

    async ungroupSchedules() {
      this.loading = true
      await this.ungroupBoardSchedule({
        group_id: this.circuits[0].group_id
      }).catch(err => {
        if (err.response) {
          this.showErrorMessage = true
          this.errorMessage = err.response.data.message
        }
      })
      await this.submit(true)
      !this.editing && this.reset()
    },

    async submit() {
      if (this.editing) {
        this.loading = true
        let firstTable = this.firstTable.filter(
          (v, i, a) => a[i].edited === true
        )
        let secondTable = this.secondTable.filter(
          (v, i, a) => a[i].edited === true
        )
        this.circuits = firstTable.concat(secondTable)

        await this.updateSchedule({
          schedules: this.circuits
        }).catch(err => {
          if (err.response) {
            this.showErrorMessage = true
            this.errorMessage = err.response.data.message
          }
        })
        this.reset()
      }
      this.showActionButtons = false
    },

    reset() {
      this.circuits = []
      this.editing = false
      this.loading = false
      this.leftPoles = this.getPoles('left')
      this.rightPoles = this.getPoles('right')
    },

    textAreaAdjust(refName) {
      const el = this.$refs[refName][0]
      el.style.height = 'auto'
      el.style.height = `${el.scrollHeight}px`
    }
  },

  created() {
    this.$root.$on('boardLoaded', () => {
      this.leftPoles = this.getPoles('left')
      this.rightPoles = this.getPoles('right')
    })
  }
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 400px) {
  button.isMobile {
    font-size: 12px;
    width: 120px !important;
    &.cancel {
      margin: 12px 12px 12px 12px !important;
    }
    &.group {
      margin: 12px 12px 12px 0 !important;
    }
    &.ungroup {
      margin: 12px 12px 12px 0 !important;
    }
    &.save {
      margin: 12px 0 12px 0 !important;
    }
  }
}

.rcd-checkbox {
  pointer-events: none;
}

.rcd-toggle {
  display: flex;
  align-items: center;
  margin: auto 0;
  margin-right: 16px;

  &.isMobile ::v-deep .btn-primary {
    font-size: 12px;
    width: 180px !important;
  }
  ::v-deep .btn-primary {
    background: #ffffff33 0% 0% no-repeat padding-box;
    color: #ffffff;
    border: none;
    display: flex;
    align-items: center;
    padding: 5px 32px;

    &.active,
    &:focus {
      background: #ffffff33 0% 0% no-repeat padding-box;
      .custom-control-label::before {
        background-color: #90e05d;
        border-color: #90e05d;
      }
    }
  }
}

.btn {
  background: #ffffff33 0% 0% no-repeat padding-box;
  border: none;
}
.table thead th {
  vertical-align: middle;
}
.table th,
.table td {
  padding: 0.7rem;
}
.table-hover tbody tr:hover {
  color: #212529;
  background-color: #e7f0fb;
}
.floating-bar {
  margin-left: 140px;
  position: fixed;
  z-index: 1;
  bottom: 40px;
  display: flex;
  width: 900px;
  height: auto !important;
  background: transparent linear-gradient(95deg, #009ee9 0%, #0060e2 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 10px;
  flex-wrap: nowrap;

  .rcd-toggle {
    order: initial !important;
  }

  &.isMobile {
    height: 180px;
    width: 92%;
    margin-left: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    padding-bottom: 12px;

    .rcd-toggle {
      order: 5 !important;
      margin-right: 0;
      margin-left: 12px;
      //   margin-top: 8px;
    }
  }
}
.table {
  font-size: 14px;
}
td {
  vertical-align: middle;
  &.cb-no {
    height: 63px !important;
    padding: 0;
  }
}
textarea {
  resize: none;
  vertical-align: middle;
}
textarea::-webkit-scrollbar {
  width: 5px;
}
textarea::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 3px #dee2e6;
}
textarea::-webkit-scrollbar-thumb {
  background-color: darkgrey;
}

.rcd-protected {
  background-color: #c6ecae;
}
</style>
